import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import { State, toggleFlag } from "@store";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../../../components";
import { applications } from "./applications";

type Props = {
  target: "SELF" | "MULTIPLE";
};

export const DisclaimerModal: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { MULTIPLE_USERS_DISCLAIMER_MODAL_SHOWN } = useSelector(
    (state: State) => state.flags
  );

  // Helpers

  function toggleDisclaimerModalFlag(): void {
    dispatch(toggleFlag("MULTIPLE_USERS_DISCLAIMER_MODAL_SHOWN"));
  }

  function isModalOpen(): boolean {
    return (
      props.target === "MULTIPLE" && !MULTIPLE_USERS_DISCLAIMER_MODAL_SHOWN
    );
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={toggleDisclaimerModalFlag}
      open={isModalOpen()}
      scroll="paper"
    >
      <DialogTitle disableTypography>
        <Grid container direction="column" spacing={2} alignItems="center">
          <Grid item>
            <Box color="warning.main">
              <WarningIcon />
            </Box>
          </Grid>
          <Grid item>
            <Typography align="center" variant="subtitle2">
              Important advisory
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography align="center" variant="body1" component="p">
              Multiple users cannot be requested for the following applications
              at this time:
            </Typography>

            {applications.map((application, index) => (
              <Typography
                key={index}
                align="center"
                variant="body1"
                color="textSecondary"
              >
                {application}
              </Typography>
            ))}
            <Typography
              align="center"
              paragraph
              variant="caption"
              component="p"
            >
              The additional forms for multiple users are currently awaiting for
              approval. Please submit one (1) request per user (e.g.
              BusinessView for 5 users must be submitted separately).
            </Typography>
            <Typography
              align="center"
              paragraph
              variant="caption"
              component="p"
            >
              Apologies for the inconvenience.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Actions>
              <Actions.Action onClick={toggleDisclaimerModalFlag}>
                Got it!
              </Actions.Action>
            </Actions>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
